import { render, staticRenderFns } from "./Trainees.vue?vue&type=template&id=80b56d70&"
import script from "./Trainees.vue?vue&type=script&lang=js&"
export * from "./Trainees.vue?vue&type=script&lang=js&"
import style0 from "./Trainees.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports